import { Field, Form } from '@kanda-libs/ks-component-ts';
import { Button, Text } from '@kanda-libs/ks-design-library';
import useStaffImitation from './useStaffImitation';
import { CLASS_NAMES, INPUT_PROPS } from './constants';

const StaffImitateUserForm = () => {
  const { form, onSubmit, isSubmitting } = useStaffImitation();

  return (
    <div className={CLASS_NAMES.wrapper}>
      <Form id="imitate-user" form={form} onSubmit={onSubmit}>
        <Text text="To imitate a user, enter their email below" />
        <Field.Input {...INPUT_PROPS} />
        <Button.Text
          submit
          id="staff-login"
          label="Login"
          isLoading={isSubmitting}
        />
      </Form>
    </div>
  );
};

export default StaffImitateUserForm;
